import axios from 'axios';
import apiConfig from 'src/config/api';
import { isTokenValid } from 'src/auth/tokenUtils';
import { Category, FileRecord } from '@twinsketch/topika-model';

class FileService {
  static getToken = () => {
    const token = localStorage.getItem('authToken');
    if (!token) throw new Error('Session expired. Please log in again.');
    return token;
  };

  static handleRequest = async (method: 'get' | 'post' | 'delete', url: string, data?: any) => {
    if (!isTokenValid()) throw new Error('Session expired. Please log in again.');

    const token = this.getToken();
    try {
      const response = await axios({
        method,
        url: `${apiConfig.API_BASE_URL}${url}`,
        data,
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        throw new Error('Session expired. Please log in again.');
      }
      console.error(`Error during ${method.toUpperCase()} request to ${url}:`, error);
      throw new Error(`Error during ${method.toUpperCase()} request`);
    }
  };

  static uploadFileWithPresignedUrl = async (
    file: File,
    linkedEntityType: 'WorkOrder' | 'Material',
    linkedEntityId: string,
    notes?: string,
    fileCategory?: Category,
    sheetNames?: string[]
  ): Promise<FileRecord> => {
    // Request a pre-signed URL from the backend
    const presignedUrlResponse = await this.handleRequest('post', '/files/upload/presigned-url', {
      fileName: file.name,
      fileType: file.type,
      linkedEntityId,
      linkedEntityType,
      notes,
      fileCategory,
      sheetNames,
    });

    const { presignedUrl, fileRecord } = presignedUrlResponse;

    // Upload the file directly to S3
    await axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    console.log('File uploaded successfully to S3 at:', presignedUrl);
    return fileRecord;
  };

  // Delete a file by its fileId
  static deleteFile = async (fileId: string, linkedEntityId: string) => {
    return await this.handleRequest('delete', `/files/${linkedEntityId}/files/${fileId}`);
  };

  static getFilesByLinkedId = async (linkedEntityId: string): Promise<FileRecord[]> => {
    return await this.handleRequest('get', `/files/${linkedEntityId}`);
  };
}

export default FileService;
